import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row, Dropdown, FormControl, InputGroup, Button } from "react-bootstrap";
import { IMAGE_PATHS, DOMAIN_URL, formatDate, base64Encode, base64Decode, toCustomCamelCase } from '../../Functions/Constant';
import API from '../../Api/Api';
import StarRating from '../../Components/StarRating'
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import UserCard from './CommanBox';
import ConfinPop from "../../Pages/ComponentPage/ConfinPop";
import LimitExtendPop from "../../Pages/ComponentPage/LimitExtendPop";

const ReviewCard = ({ review, bg }) => {
  const navigate = useNavigate();
  const loaderRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(null);
  const [draftCards, setDraftCards] = useState([]);
  const [cards, setCards] = useState([]);
  const swiperRefs = useRef({});
  const swiperRefs1 = useRef({});
  const [loading, setLoading] = useState(true);

  let userData;
  try {
    userData = JSON.parse(localStorage.getItem("userData") || "{}");
  } catch (error) {
    console.error("Error parsing userData from localStorage:", error);
    userData = {};
  }
  const getTotalSlidesDraftCards = () => {
    const slidesPerView = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
    const totalSlides = Math.ceil(draftCards.length / slidesPerView);
    console.log("getTotalSlidesDraftCards:", totalSlides, "draftCards.length:", draftCards.length, "slidesPerView:", slidesPerView, "activeIndex1:", activeIndex1, "active:", activeIndex);
    return totalSlides;
  };

  const getTotalSlides = () => {
    const slidesPerView = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
    console.log("cards.length:", cards.length, "silder:", slidesPerView);
    return Math.ceil(cards.length / slidesPerView);
  };
  const [activeIndex, setActiveIndex] = useState(0); // Track the active slide index
  const [activeIndex1, setActiveIndex1] = useState(0); // Track the active slide index
  const swiperRef = useRef(null);
  const swiperRef1 = useRef(null);

  const recentApiSearches = async () => {
    setLoading(true);
    try {
      const payload = {

        name: "rajeev",
        phone: "",
        company: "",
        school: "",
        location: ""
      };
      const response = await API.post('/business/recentsearch-user', payload);
      if (response.success) {
        setCards(response.users);
      }
    } catch (error) {
      console.error("Error fetching recent searches:", error);
    } finally {
      setLoading(false);
    }
  };

  const verifiedUser = async () => {
    setLoading(true);
    try {
      const response = await API.post('/business/verified-user');
      if (response.success) {
        setDraftCards(response.users);
      }
    } catch (error) {
      console.error("Error fetching recent searches:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    recentApiSearches();
    verifiedUser();
  }, []);
  const viewUser = async (user) => {
    try {
      window.location.href = `/profile/${user.name.replace(/\s+/g, '-').toLowerCase()}/${base64Encode(user.user_id)}`;
    } catch (error) {
      console.error("Error viewing user:", error);
    }
  };
  const rateNow = async () => {
    if (!selectedUser) return;
    const payload = {
      target_user_id: selectedUser.user_id,
    };
    try {

      const res = await API.post('/business/initiate-verification', payload);
      if (res.error_type == 1) {
        setIsExtendOpen(true);
      } else {
        localStorage.removeItem("userData");
        window.location.href = `/profile/${selectedUser.name.replace(/\s+/g, '-').toLowerCase()}/${base64Encode(selectedUser.user_id)}`;
      }

    } catch (error) {
      console.error("Error initiating rating:", error);
    } finally {
      setIsPopupOpen(false);
      setSelectedUser(null);
    }
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isExtendOpen, setIsExtendOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleRateNow = (user) => {
    if (userData?.credit_balance <= 0) {
      setIsExtendOpen(true); 
    } else {
      setSelectedUser(user);
      setIsPopupOpen(true); 
    }
  };
  return (<>

    <div
      enableReinitialize
      className={`custm-bg ${draftCards && draftCards.length > 0 || cards && cards.length > 0 ? "pt-[50px] pb-[50px] px-4" : "pb-[210px] md:pb-[170px]"
        }`}
    >

      <Container>
        <Row>
          <Col lg={12} className="p-0">
            {draftCards && draftCards.length > 0 && (
              <>
                <h3 class="text-[28px] font-bold text-black  mb-0 mt-[55px] leading-[0.9]">Recently Viewed Profiles & Ratings</h3>
                <div className="client-slider-wrapper relative review-card-container swiper-navigation-04 swiper-navigation-suggestion">
                  <Swiper
                    modules={[Pagination, Autoplay, Navigation]}
                    // autoplay={{ delay: 5000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    navigation
                    slidesPerView={3} // Default to 4 cards on large screens
                    spaceBetween={25}
                    breakpoints={{
                      0: { slidesPerView: 1 }, // 1 card on mobile (xs)
                      768: { slidesPerView: 2 }, // 2 cards on tablet (md)
                      1024: { slidesPerView: 3 }, // 4 cards on laptop/desktop (lg)
                    }}
                    onSwiper={(swiper) => {
                      swiperRefs1.current = swiper;
                      swiper.autoplay?.stop(); // Stop autoplay initially if desired
                    }}
                    onSlideChange={(swiper) => {
                      setActiveIndex1(swiper.activeIndex); // Update active index on slide change
                    }}
                    ref={swiperRef1}
                    className="slider_suggestion pt-[15px] w-full h-auto pb-4 "

                  >
                    {draftCards.map((card) => (
                      <SwiperSlide key={card.user_id}>
                        <div className="relative">
                          <UserCard user={card} viewUser={viewUser} rateNow={handleRateNow} />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {
                    draftCards && draftCards.length > 3 && (
                      <>
                        {activeIndex1 > 0 && (<div onClick={() => swiperRef1.current.swiper.slidePrev()} className="swiper-button-prev absolute " style={{ left: "15px" }}> <i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingRight: "5px" }} className="solid-icon-Arrow-Left"></i></div>)}
                        {activeIndex1 < draftCards.length - 3 && (<div onClick={() => swiperRef1.current.swiper.slideNext()} className="swiper-button-next absolute " style={{ right: "15px" }}><i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingLeft: "5px" }} className="solid-icon-Arrow-Right"></i></div>)}

                      </>
                    )
                  }
                </div>

              </>
            )}
          </Col>
        </Row>
      </Container>
    </div>
    {cards && cards.length > 0 && (
      <section enableReinitialize className={`${bg} pt-[20px] pb-[60px] px-4`}>
        <Container>

          <Row>

            <Col lg={12} className="p-0">

              <>
                <h3 class="text-[28px] font-bold text-black  mb-0 mt-[55px] leading-[0.9]">Recent Search History</h3>
                <div className="client-slider-wrapper relative review-card-container swiper-navigation-04 swiper-navigation-suggestion">
                  <Swiper
                    modules={[Pagination, Autoplay, Navigation]}
                    // autoplay={{ delay: 5000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    navigation
                    slidesPerView={3} // Default to 4 cards on large screens
                    spaceBetween={25}
                    breakpoints={{
                      0: { slidesPerView: 1 }, // 1 card on mobile (xs)
                      768: { slidesPerView: 2 }, // 2 cards on tablet (md)
                      1024: { slidesPerView: 3 }, // 4 cards on laptop/desktop (lg)
                    }}
                    onSwiper={(swiper) => {
                      swiperRefs.current = swiper;
                      swiper.autoplay?.stop(); // Stop autoplay initially if desired
                    }}
                    onSlideChange={(swiper) => {
                      setActiveIndex(swiper.activeIndex); // Update active index on slide change
                    }}
                    ref={swiperRef}
                    className="slider_suggestion pt-[15px] w-full h-auto pb-4 "

                  >
                    {cards.map((card) => (
                      <SwiperSlide key={card.user_id} className=" ">
                        <div className="relative">
                          <UserCard user={card} viewUser={viewUser} rateNow={handleRateNow} />
                        </div>
                      </SwiperSlide>

                    ))}
                  </Swiper>
                  {
                    cards && cards.length > 3 && (
                      <>
                        {activeIndex > 0 && (<div onClick={() => swiperRef.current.swiper.slidePrev()} className="swiper-button-prev absolute " style={{ left: "15px" }}> <i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingRight: "5px" }} className="solid-icon-Arrow-Left"></i></div>)}
                        {activeIndex < cards.length - 3 && (<div onClick={() => swiperRef.current.swiper.slideNext()} className="swiper-button-next absolute " style={{ right: "15px" }}><i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingLeft: "5px" }} className="solid-icon-Arrow-Right"></i></div>)}

                      </>
                    )
                  }
                </div>

              </>

            </Col>
          </Row>


        </Container>
      </section >


    )}
    <ConfinPop
      isOpen={isPopupOpen}
      onClose={() => setIsPopupOpen(false)}
      onConfirm={rateNow}
    />
      <LimitExtendPop
      isOpen={isExtendOpen}
      onClose={() => setIsExtendOpen(false)}
    />
  </>
  );
};



export default ReviewCard;
